/**
 * Lists all possible usPower values.
 */
export default [
  { key: 10, value: '10' },
  { key: 20, value: '20' },
  { key: 30, value: '30' },
  { key: 40, value: '40' },
  { key: 50, value: '50' },
  { key: 60, value: '60' },
  { key: 70, value: '70' },
  { key: 80, value: '80' },
  { key: 90, value: '90' },
  { key: 100, value: '100' },
]
